module.exports = __webpack_public_path__ + "static/media/HealthcareLifeSciences.c7a84e44.svg";